var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAddWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.54297 7.94234L7.54297 13.5996H5.65723L5.65723 7.94234L0 7.94234V6.05757L5.65723 6.05757L5.65723 0.400345L7.54297 0.400345L7.54297 6.05757L13.1992 6.05757V7.94234L7.54297 7.94234Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddWhite);
export default __webpack_public_path__ + "static/media/Icon_Add_White.d3c2391ca3a88fd153c3a9aafb5f5c5c.svg";
export { ForwardRef as ReactComponent };